import "./Header.css";

function Header(){

    return (
        <div className="header">
            <div className="header-container">
                <a href="https://www.fit.edu/">
                    <img src="FT_logo.png" alt="Florida Tech Website"/>
                </a>
            </div>
        </div>
    );
}

export default Header;